"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useFormReducer;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _react = require("react");

function useFormReducer(form, initialState, extendReducer) {
  var reducer = function reducer(state, action) {
    if (typeof action === 'string') {
      action = {
        type: action,
        data: form.getFieldValue(action)
      };
    }

    var newState = {};
    newState[action.type] = action.data;
    newState = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), newState);

    if (extendReducer) {
      newState = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, newState), extendReducer(newState, action));
    }

    return newState;
  };

  return (0, _react.useReducer)(reducer, initialState);
}